import { createUseQuery } from 'api/common/createUseQuery'
import { fetchVisibilityUsers, VisibilityUser } from 'api/fetchers/visibility/fetchVisibilityUsers'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useVisibilityUsers = createUseQuery({
  queryKey: ApiQueryKeys.PREFERENCES_VISIBILITY_USERS,
  fetcher: fetchVisibilityUsers,
  selector: res => res?.data?.records ?? ({} as VisibilityUser[]),
})
